import React, { useState } from "react";
import { Button, Tooltip } from "@mui/material";
import { RefreshIcon, FillGapsIcon } from "assets";
import { ExtrapolationModal } from "../extrapolationModal";
import { ExtrapolationActionType } from "../../types";

type BulkActionsButtonsProps = {
    selectedCollectorIds: string[];
    onRefreshAfterSave?: () => void;
};

export const BulkActionsButtons = ({
    selectedCollectorIds,
    onRefreshAfterSave,
}: BulkActionsButtonsProps) => {
    const [isExtrapolationModalOpen, setIsExtrapolationModalOpen] = useState(false);
    const [extrapolationActionType, setExtrapolationActionType] = useState<ExtrapolationActionType | null>(null);

    const openExtrapolationModal = (actionType: ExtrapolationActionType) => {
        setExtrapolationActionType(actionType);
        setIsExtrapolationModalOpen(true);
    };

    const closeExtrapolationModal = () => {
        setIsExtrapolationModalOpen(false);
        setExtrapolationActionType(null);
    };

    const onRefreshExtrapolationClick = () => {
        openExtrapolationModal("refreshExtrapolation");
    };

    const onFillGapsClick = () => {
        openExtrapolationModal("fillGaps");
    };

    const isFillGapsAction = extrapolationActionType === "fillGaps";

    return (
        <>
            <Tooltip arrow placement="top" title="Refresh existing extrapolated values using the latest usage data">
                <Button
                    startIcon={<RefreshIcon />}
                    variant="contained"
                    sx={{ borderRadius: "8px", width: 'fit-content' }}
                    disabled={selectedCollectorIds.length === 0}
                    onClick={onRefreshExtrapolationClick}
                >
                    Refresh Extrapolation
                </Button>
            </Tooltip>
            <Tooltip arrow placement="top" title="Bulk fill missing days with estimated usage data">
                <Button
                    startIcon={<FillGapsIcon />}
                    variant="contained"
                    sx={{ borderRadius: "8px", width: 'fit-content' }}
                    disabled={selectedCollectorIds.length === 0}
                    onClick={onFillGapsClick}
                >
                    Fill Gaps
                </Button>
            </Tooltip>
            {isExtrapolationModalOpen && <ExtrapolationModal
                isOpen={isExtrapolationModalOpen}
                onClose={closeExtrapolationModal}
                onSaveButtonClick={onRefreshAfterSave ?? (() => { })}
                selectedCollectorIds={selectedCollectorIds}
                isFillGapsAction={isFillGapsAction}
            />}
        </>
    );
};